import * as React from "react";
import { Row, Col, Form, InputGroup } from "react-bootstrap";
import {
  SearchIcon,
  PaginationLeft,
} from "../../../../components/ui/icons";
import TableView from "../../../../components/tableView";
import Modal4CreateNewOrgAdmin from "../../../../components/modals/createNewOrgAdmin";
import { DataAvailabilityMessages, routes } from "../../../../common/constants";
import { Link, useLocation } from "react-router-dom";
import useUserTable from "../../useUserTable";
import OrganizationUsersColumns from "./organizationUsersColumns";
import DebouncedInput from "../../../../components/tableView/debouncedInput";
import '../../users.scss';
import '../superadminusers.scss';
import { userList } from "../../listUserSlice";
import { groupList } from "../../../deviceManagement/groupSlice";
import { useDispatch } from "react-redux";
const OrgnaizationUsers = () => {
  const columns = OrganizationUsersColumns();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const organizationName = queryParams.get("orgName");
  const organizationId = queryParams.get("orgId");
  const { rows, globalFilter, setGlobalFilter } = useUserTable(organizationId);
  const dispatch = useDispatch();
  
  React.useEffect(() => {
    dispatch(userList(organizationId));
    dispatch(groupList(organizationId));
  }, []);

  return (
    <div className="admin-users-container superadmin_users_container">
      <Col>
        <div className="dm-heading-container">
          <Row>
            <Col sm={3}>
              <div className="heading">
                <Link to={routes.superAdmin}>
                  <PaginationLeft />
                </Link>
                {organizationName}
              </div>
            </Col>
            <Col sm={9}>
              <div className="users-add-role-container">
                <div className="user-search-input">
                  <InputGroup>
                    <DebouncedInput
                      value={globalFilter ?? ""}
                      onChange={(value) => setGlobalFilter(String(value))}
                      placeholder="Search"
                      aria-describedby="org-user-search"
                    />
                    <InputGroup.Text id="org-user-search">
                      <SearchIcon />
                    </InputGroup.Text>
                  </InputGroup>
                </div>
                <div className="user-add-role-btn">
                  <Modal4CreateNewOrgAdmin />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col>
        <div className="dm-body">
          <Row>
            <Col sm={12}>
              <div className="dm-table-container">
                <TableView
                  data={rows}
                  columns={columns}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  noDataMessage={DataAvailabilityMessages.NO_USER_AVAILABLE}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </div>
  );
};

export default OrgnaizationUsers;
